import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
  collapsibleHeader?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, showFooter = true, collapsibleHeader = false }) => {
  const [headerVisible, setHeaderVisible] = useState(false);

  if (collapsibleHeader) {
    return (
      <div className="layout layout--collapsible">
        {/* Wrapper gives the tab a relative anchor point */}
        <div className="layout-header-wrap">
          <div className={`layout-collapsible-header${headerVisible ? ' layout-collapsible-header--visible' : ''}`}>
            <div className="layout-collapsible-header-inner">
              <Header />
            </div>
          </div>
          {/* Tab hangs off the bottom of the header at all times */}
          <button
            className="layout-header-tab"
            onClick={() => setHeaderVisible(v => !v)}
            aria-label={headerVisible ? 'Hide navigation' : 'Show navigation'}
          >
            {headerVisible ? '\u25b2' : '\u25bc'}
          </button>
        </div>

        <main className="main-content">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
};

export default Layout;
